import { useState } from "react";
import {
  Box,
  Button,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxTooltip from "../../../../../components/SbuxTooltip";
import SbuxTranslate from "../../../../../components/SbuxTranslate";
import SbuxDialog2 from "../../../../../components/SbuxDialog2";
import { ellipse, getTitleForEllipse } from "../../../../../utils/stringUtil";
import useCss from "../../../../../hooks/useCss";
import { StyledDeleteButton } from "../../styled";
import styles from "./styles";

interface Props {
  row: Record<string, unknown>;
  handleEditRowClick?: (row: Record<string, unknown>) => void;
  handleDeleteRowClick?: (row: Record<string, unknown>) => void;
}

const ResourceRow = ({
  row,
  handleEditRowClick,
  handleDeleteRowClick,
}: Props) => {
  const classes = useCss(styles);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleEditClick = () => {
    if (handleEditRowClick) {
      handleEditRowClick(row);
    }
  };

  const toggleDialogOpen = () => {
    setOpenConfirmDialog(!openConfirmDialog);
  };

  const handleOnClickDeleteEvent = () => {
    setOpenConfirmDialog(true);
  };

  const dialogConfig = {
    title: "Confirm",
    hasBackdrop: false,
    asModal: true,
  };

  return (
    <>
      <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {String(row["lob"] ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {String(row["name"] ?? "")}
        </SbuxStyledTableCell>
        <SbuxTooltip
          title={getTitleForEllipse(row.resourceName as string | undefined)}
          placement="right"
        >
          <SbuxStyledTableCell
            className={classes.cellFocus}
            onClick={handleEditClick}
          >
            {ellipse(
              row["resourceName"] as string | null | undefined,
              Number(process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS),
            )}
          </SbuxStyledTableCell>
        </SbuxTooltip>
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          <a
            href={row["resourceUrl"] as string | undefined}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {ellipse(
              row["resourceUrl"] as string | null | undefined,
              Number(process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS),
            )}
          </a>
        </SbuxStyledTableCell>
        <SbuxStyledTableCell>
          <StyledDeleteButton
            onClick={handleOnClickDeleteEvent}
            disableFocusRipple
            disableRipple
          />
        </SbuxStyledTableCell>
      </SbuxStyledTableRow>

      {openConfirmDialog && (
        <SbuxDialog2
          open={openConfirmDialog}
          config={dialogConfig}
          handleOnClose={toggleDialogOpen}
        >
          <DialogContent dividers>
            <Typography variant="h5">
              <SbuxTranslate>{`Are you sure you want to delete `}</SbuxTranslate>
              <span>{`${row["resourceName"]}?`}</span>
            </Typography>
          </DialogContent>

          <DialogActions>
            <Box className="actionContainer">
              <Button
                variant="contained"
                size="medium"
                onClick={() => {
                  handleDeleteRowClick?.(row);
                  setOpenConfirmDialog(false);
                }}
              >
                Okay
              </Button>
              <Button
                variant="outlined"
                size="medium"
                onClick={() => {
                  setOpenConfirmDialog(false);
                }}
              >
                Cancel
              </Button>
            </Box>
          </DialogActions>
        </SbuxDialog2>
      )}
    </>
  );
};

export default ResourceRow;
